<template>
  <section class="studios_list pb-5">
    <!-- pinned space -->
    <transition name="fade">
      <div class="cine_academies_lists mt-5" v-if="pinnedSpace">
        <v-row>
          <v-col cols="12">
            <router-link :to="{ name: 'studiosDetails', params: { id: (pinnedSpace.slug ?? pinnedSpace.id) } }">
              <div class="pinned-space">
                <div class="studio-item mx-3">
                  <div class="img">
                    <img class="img-fluid main-img" :src="pinnedSpace.main_image_url" alt="studio"/>
                    <div class="rate" v-if="pinnedSpace.totalRates > 0">
                      <span>{{ pinnedSpace.totalRates }}</span>
                      <img class="img-fluid" src="/img/newMainPage/star.png" alt="star icon">
                    </div>
                  </div>
                  <div class="_info text-start mt-4">
                    <span class="Name text-start"> {{ pinnedSpace.name }} </span>
                    <div class="d-flex align-items-center gap-5 categories-div">
                      <div class="d-flex align-items-center">
                        <img class="img-fluid" src="/img/newMainPage/location.svg" alt="location icon">
                        &nbsp;&nbsp;<span>{{ pinnedSpace.city_name }}</span>
                      </div>
                      <div class="d-flex align-items-center">
                        <img class="img-fluid" src="/img/newMainPage/category.svg" alt="category icon">
                        &nbsp;&nbsp;<span>{{ pinnedSpace.category_name }}</span>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center flex-row mt-4">
                      <router-link
                          :to="{ name: 'studiosDetails', params: { id: (pinnedSpace.slug ?? pinnedSpace.id) } }">
                      <span class="d-inline-flex align-items-center show-more-link">
                        {{ $t("order-now") }}&nbsp;&nbsp;<i class="mdi mdi-arrow-top-left"></i>
                      </span>
                      </router-link>
                      <span class="price">
                      {{ pinnedSpace.native_rent_price }}
                      <img class="img-fluid" src="/img/newMainPage/sar.svg" alt="sar icon">
                      /
                      {{ pinnedSpace.native_rent_type }}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </v-col>
        </v-row>
      </div>
    </transition>

    <!-- show spaces -->
    <div class="cine_academies_lists mt-5" v-if="studiosList.length > 0">
      <v-row :class="showMap ? 'scroll-div' : ''">
        <v-col :class="showMap ? 'col-12 col-sm-6 col-lg-12' : 'col-12 col-sm-6 col-lg-4'"
               v-for="(list, index) in studiosList" :key="index">
          <div class="studio-item mx-3">
            <div class="img">
              <img class="img-fluid main-img" :src="list.main_image_url" alt="studio"/>
              <div class="rate" v-if="list.totalRates > 0">
                <span>{{ list.totalRates }}</span>
                <img class="img-fluid" src="/img/newMainPage/star.png" alt="star icon">
              </div>
            </div>
            <div class="_info text-start mt-4">
              <span class="Name text-start"> {{ list.name }} </span>
              <div class="d-flex align-items-center gap-5 categories-div">
                <div class="d-flex align-items-center">
                  <img class="img-fluid" src="/img/newMainPage/location.svg" alt="location icon">
                  &nbsp;&nbsp;<span>{{ list.city_name }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <img class="img-fluid" src="/img/newMainPage/category.svg" alt="category icon">
                  &nbsp;&nbsp;<span>{{ list.category_name }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center flex-row mt-4">
                <router-link :to="{ name: 'studiosDetails', params: { id: (list.slug ?? list.id) } }">
                      <span class="d-inline-flex align-items-center show-more-link">
                        {{ $t("order-now") }}&nbsp;&nbsp;<i class="mdi mdi-arrow-top-left"></i>
                      </span>
                </router-link>
                <span class="price">
                      {{ list.native_rent_price }}
                      <img class="img-fluid" src="/img/newMainPage/sar.svg" alt="sar icon">
                      /
                      {{ list.native_rent_type }}
                    </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-if="studiosList.length === 0 && !loadingData">
      <NoData/>
    </div>
    <div v-if="loadingData">
      <v-row>
        <v-col cols="12" md="12">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="12">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import firebase from "firebase/app";
import "firebase/messaging";
import NoData from "@/views/no-data.vue";

export default {
  props: ["showMap", "pinnedSpace", "studiosList", "loadingData"],
  components: {
    NoData,
  },
  data() {
    return {
      attrs: {
        class: "mb-2",
        boilerplate: true,
      },
    };
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped lang="scss">
.studio-item {
  position: relative;
  background: #FFF;
  border-radius: 20px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
  margin: 10px 0;

  @media(max-width: 1263px) {
    direction: rtl !important
  }

  .img {
    position: relative;

    .main-img {
      width: 100%;
      height: 300px;
      position: relative;
      object-fit: cover;
      border-radius: 30px;
      padding: 24px;
      @media (max-width: 768px) {
        height: 200px;
        border-radius: 24px;
        padding: 16px;
      }
    }
  }

  .fav-icon {
    position: absolute;
    top: 22px;
    right: 32px;
    z-index: 9;

    i {
      font-size: 32px;

      &.active {
        color: #E61B42;
      }
    }
  }

  .rate {
    position: absolute;
    top: 32px;
    left: 32px;
    padding: 4px 8px;
    z-index: 9;
    border-radius: 4px;
    opacity: 0.6;
    background: #000;
    backdrop-filter: blur(30px);
    display: inline-flex;
    align-items: start;
    gap: 5px;

    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }

    span {
      color: #FFF;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }
  }

  ._info {
    padding: 0 20px 20px 20px;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* number of lines to show */
      color: #8D8D8D;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
    }

    .Name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* number of lines to show */
      color: #000;
      font-size: 24px;
      line-height: 32px; /* 140% */
      font-style: normal;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .price {
      color: #333;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      display: inline-flex;
      align-items: center;
      gap: 5px;

      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
    }

    .show-more-link {
      border-radius: 8px;
      background: #F4F4F4;
      color: #000;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 26px;
      padding: 12px 32px;
    }

    .show-more-link:hover {
      background: #000;
      color: #fff;
      transition: 300ms ease-in-out;
    }

    @media (max-width: 768px) {
      padding: 0 16px 16px 16px;

      span {
        line-height: 12px; /* fallback */
        max-height: 24px; /* fallback */
        font-size: 10px;
      }

      .Name {
        line-height: 14px; /* fallback */
        max-height: 28px; /* fallback */
        font-size: 12px;
        font-weight: 700;
      }

      .price {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .show-more-link {
        border-radius: 8px;
        font-size: 14px;
        line-height: 18px;
        padding: 20px 24px;
      }
    }

    .categories-div {
      img {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      span {
        color: #5B5B5B;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 26px;
      }

      @media (max-width: 768px) {
        img {
          width: 16px;
          height: 16px;
        }

        span {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
}

.pinned-space {
  border-left: 3px solid #111;
  padding-left: 10px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}

.scroll-div {
  overflow-y: scroll;
  height: 72vh;
}
</style>
